export default __webpack_public_path__ + "static/media/davi-marcos.16dc78f2.jpg";